/**
 * @generated SignedSource<<967211bb55e25e2d52a6757257a1cbb5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyMobileNav_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyMobileNavRefineMenuFilters_user" | "SbMobileAppliedFilters_user">;
  readonly " $fragmentType": "BuyMobileNav_user";
};
export type BuyMobileNav_user$key = {
  readonly " $data"?: BuyMobileNav_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyMobileNav_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyMobileNav_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileAppliedFilters_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyMobileNavRefineMenuFilters_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "0771884fad1c66618474f3286aafcba1";

export default node;
